import { analytics } from '@saucelabs/sl-util-axios';

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Arbitrary key is allowed but only certain
 *                                   are supported in the UI. Check out reducers.js.
 */
export function getFilters(params) {
  return analytics.get('/_filters', { params });
}

export function searchMetadata({ params }) {
  return analytics.get('/_filters/search', { params });
}
